import React from 'react';

interface WithAuthenticationProps {
}

export default function withAuthentication<P extends object>(
    WrappedComponent: React.ComponentType<P>
) {
    const WithAuthentication = (props: P & WithAuthenticationProps): React.ReactElement => {
        return <WrappedComponent {...(props as P)} />;
    };

    return WithAuthentication;
}
